<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h4 style="color: white;">Administración de Fuentes</h4>
    </div>
    <div class="card-body">
      <div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Toolbar with button groups">
        <div class="d-grid d-md-block">
          <button type="button" class="btn btn-secondary" (click)="regresarDirectorio()">Volver</button>
          <button type="button" class="btn btn-primary" (click)="goNuevafuente()">+ Crear Fuente</button>
          <button type="button" class="btn btn-success" id="exportar" (click)="download()">Generar EXCEL</button>
        </div>
      </div>
      <br>
      <div class="container-fluid overflow-scroll">
        <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
         id="table2excel">
          <thead>
            <tr>
              <th scope="col" class="text-center">NIT</th>
              <th scope="col" class="text-center">Razón Social</th>
              <th scope="col" class="text-center">Operación Estadísticas</th>
              <th scope="col" class="text-center">Código Entidad</th>
              <th scope="col" class="text-center">Departamento</th>
              <th scope="col" class="text-center">Teléfono</th>
              <th scope="col" class="text-center">Email</th>
              <th scope="col" class="text-center">Estado</th>
              <th scope="col" class="text-center">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let fuente of fuentesVista">
              <td scope="col" >{{fuente.nit}}</td>
              <td scope="col" >{{fuente.nombEntidad}}</td>
              <td scope="col" >{{fuente.operacion.nombre}} - {{fuente.operacion.descripcion}}</td>
              <td scope="col" >{{fuente.codEnti}}</td>
              <td scope="col" >{{fuente.depto}}</td>
              <td scope="col" >{{fuente.telefono}}</td>
              <td scope="col" >{{fuente.email}}</td>
              <td scope="col" >{{fuente.idEstado.nombre}}</td>
              <td scope="col" class="text-center" id="opciones">
                <div class="container">
                  <div class="row">
                    <div class="col-1" *ngIf="fuente.idEstado.id == 1">
                      <a type="button" class="fa fa-edit" (click)="goEditarfuente(fuente.id)" style="color: green;"></a>
                    </div>
                    <div class="col-1" *ngIf="fuente.idEstado.id == 2">
                      <a type="button" class="fa fa-edit"  style="color: gray;"></a>
                    </div>
                    <div class="col-1">
                      <a type="button" class="fa fa-check-square" data-bs-toggle="modal" data-bs-target="#modalActi"
                      (click)="EstadoFuente(fuente)" style="color: gray;"></a> <!--(click)="goActivarFuente(fuente)"-->
                    </div>
                    <div class="col-1">
                      <a type="button" class="fa fa-calendar-check" data-toggle="modal" data-target="#modal-Historia"
                      data-bs-toggle="tooltip" data-bs-placement="right" title="Historia de activación" (click)="histActivacionFuente(fuente)" style="color: blue;"></a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>



  <div style="display: none;">
    <table id="table2excel22">
      <thead>
        <tr>
          <th scope="col" class="text-center">NIT</th>
          <th scope="col" class="text-center">Razón Social</th>
          <th scope="col" class="text-center">Operación Estadísticas</th>
          <th scope="col" class="text-center">Código Entidad</th>
          <th scope="col" class="text-center">Departamento</th>
          <th scope="col" class="text-center">Teléfono</th>
          <th scope="col" class="text-center">Email</th>
          <th scope="col" class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fuente of fuentesVista">
          <td scope="col" >{{fuente.nit}}</td>
          <td scope="col" >{{fuente.nombEntidad}}</td>
          <td scope="col" >{{fuente.operacion.nombre}} - {{fuente.operacion.descripcion}}</td>
          <td scope="col" >{{fuente.codEnti}}</td>
          <td scope="col" >{{fuente.depto}}</td>
          <td scope="col" >{{fuente.telefono}}</td>
          <td scope="col" >{{fuente.email}}</td>
          <td scope="col" >{{fuente.idEstado.nombre}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</body>


<!--activar-activar-->
<button class="btn btn-primary btn-sm" #openModalActivar data-bs-toggle="modal"  data-bs-target="#modalActi" style="visibility: hidden;" data-bs-backdrop="static" data-bs-keyboard="false">ModCargar</button>
<div class="modal fade bd-example-modal-lg" id="modalActi" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <!--h5 class="modal-title" id="modalActi">Inactivar/Activar</h5-->
        <h4 style="color: white;" *ngIf="EstadoActual=='2'">Activar Fuente</h4>
        <h4 style="color: white;" *ngIf="EstadoActual=='1'">Inactivar Fuente</h4>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <!--app-activacion></app-activacion-->
        <form>
          <div class="container-fluid">
            <div class="row">
              <div class="col-4">
                <div><label><b>Código</b></label></div>
                <div><input class="form-control" type="text" name="codigo" [(ngModel)]="fuenteActivar.codEnti" disabled></div>
              </div>
              <div class="col-8">
                <div><label><b>Razón Social</b></label></div>
                <div><input class="form-control" type="text" name="nombreEntidad" [(ngModel)]="fuenteActivar.nombEntidad" disabled></div>
              </div>
            </div>
          </div>
          <br>
          <div class="container-fluid">
            <div class="row">
              <div><label><b>Observación</b></label></div>
              <div><textarea class="form-control" type="text" name="observacion" [(ngModel)]="nuevaActivacionFuente.observacion" rows="4" cols="12" maxlength="255"></textarea></div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closeModalActivar data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="iniciaGuardadoActivacion()">Guardar</button>
      </div>
    </div>
  </div>
</div>

<!--historial activacion-->
<div class="modal fade bd-example-modal-lg" id="modal-Historia" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" style="color: white;">Historia de Activación</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-4">
              <div><label><b>NIT</b></label></div>
              <div><input class="form-control" type="text" name="codigo" [(ngModel)]="fuenteActivar.nit" disabled></div>
            </div>
            <div class="col-8">
              <div><label><b>Razón Social</b></label></div>
              <div><input class="form-control" type="text" name="nombreEntidad" [(ngModel)]="fuenteActivar.nombEntidad" disabled></div>
            </div>
          </div>
        </div>
        <br>
        <div class="container-fluid overflow-scroll">
          <table class="table table-bordered row-border hover datatable" id="tablahist">
            <thead>
              <tr>
                <th scope="col-1" class="text-center">Fecha</th>
                <th scope="col-2" class="text-center">Usuario</th>
                <th scope="col-3" class="text-center">Acción</th>
                <th scope="col-4" class="text-center">Observaciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let h of histoEntidad | paginate:{ itemsPerPage: 10, currentPage: page }">
                <td>{{h.fecha | date:'dd/MM/yyyy'}}</td>
                <td>{{h.usuarioMod}}</td>
                <td>{{h.accion}}</td>
                <td style="word-wrap: break-word; word-break: break-all; overflow-wrap: break-word;">
                  <p>{{h.observacion}}</p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row justify-content-end">
            <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>

<!--Modal confirmar-->
<button class="btn btn-primary btn-sm" #openmodalconfirmar data-bs-toggle="modal"  data-bs-target="#modal-confirmar" style="visibility: hidden;" data-bs-backdrop="static" data-bs-keyboard="false">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-confirmar" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" id="modalheader" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="ModalLabel" style="color: white;">Confirmar</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" #cerrarmodalconfirmar
              style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid">
          <br>
          <div class="row">
            <div *ngIf="EstadoActual=='2'" class="row" style="text-align: center;">
              <p>Confirma que desea <b>activar</b> la fuente <b>{{fuenteActivar.nombEntidad}}</b> con código de entidad <b>{{fuenteActivar.codEnti}}</b></p>
            </div>
            <div *ngIf="EstadoActual=='1'" class="row" style="text-align: center;">
              <p>Confirma que desea <b>inactivar</b> la fuente <b>{{fuenteActivar.nombEntidad}}</b> con código de entidad <b>{{fuenteActivar.codEnti}}</b></p>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancelarConfirmar()">Cancelar</button>
        <button type="submit" class="btn btn-primary" (click)="guardarActivacion()">Confirmar</button>
      </div>
    </div>
  </div>
</div>
